import { type OfferV11 } from '@redteclab/api/clients/bully'

import { productAccessorGetBestSellerPromotionFromOffer } from './productAccessorGetBestSellerPromotionFromOffer'

export const productAccessorIsSellerPromotionAvailable = (
  offer: OfferV11 | undefined,
): boolean => {
  if (!offer) {
    return false
  }

  const sellerPromotion = productAccessorGetBestSellerPromotionFromOffer(offer)

  return Boolean(sellerPromotion)
}
